export default __webpack_public_path__ + "static/media/about5.c58d5ecc.jpg";